import { TextTeaserSchemeDefinition } from "./text-teaser-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createTextTeaserMapDefinition } from "../../../utils/scheme-helper";

export const TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_L = "l";
export const TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_XL = "xl";
export const TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_XXL = "xxl";

export const TEASER_TEXT_NUMBER_VALUE_TEXT_SIZES = [
  TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_L,
  TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_XL,
  TEASER_TEXT_NUMBER_VALUE_TEXT_SIZE_XXL
] as const;

function createSchemes() {
  let newSchemes: AllColors.TextTeaserSchemeConfiguration<TextTeaserSchemeDefinition> = {};

  AllColors.TEXT_TEASER_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      valueTextColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      contentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      contentBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      linkHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      gradientColor: ""
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const TEXT_TEASER_SCHEME_CONFIG: AllColors.TextTeaserSchemeConfiguration<TextTeaserSchemeDefinition> = createSchemes();

export const TEXT_TEASER_SCHEME_MAP: Map<BackgroundColor | "default", TextTeaserSchemeDefinition> = new Map(
  Object.entries(createTextTeaserMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    TEXT_TEASER_SCHEME_CONFIG[config as string]
  ])
);
